const STORAGE_KEY = "cliptranscript_auth_redirect";

export function isSafeRedirectPath(path) {
  if (typeof path !== "string") return false;
  if (!path.startsWith("/")) return false;
  if (path.startsWith("//")) return false;
  return true;
}

/** Call on sign-in/sign-up page mount so OAuth round-trips keep the return URL. */
export function persistAuthRedirectFromSearch(searchParams) {
  const r = searchParams.get("redirect");
  if (r && isSafeRedirectPath(r)) {
    try {
      sessionStorage.setItem(STORAGE_KEY, r);
    } catch {
      /* ignore */
    }
  }
}

export function getAuthRedirectTarget(searchParams) {
  const fromUrl = searchParams.get("redirect");
  if (fromUrl && isSafeRedirectPath(fromUrl)) {
    try {
      sessionStorage.setItem(STORAGE_KEY, fromUrl);
    } catch {
      /* ignore */
    }
    return fromUrl;
  }
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored && isSafeRedirectPath(stored)) return stored;
  } catch {
    /* ignore */
  }
  return "/dashboard";
}

export function clearAuthRedirect() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function signupHrefWithRedirect(redirectPath) {
  if (redirectPath && isSafeRedirectPath(redirectPath)) {
    return `/signup?redirect=${encodeURIComponent(redirectPath)}`;
  }
  return "/signup";
}

export function signinHrefWithRedirect(redirectPath) {
  if (redirectPath && isSafeRedirectPath(redirectPath)) {
    return `/signin?redirect=${encodeURIComponent(redirectPath)}`;
  }
  return "/signin";
}
